import * as React from 'react';

const PullRight = ({ children }) => (
  <div className="pull-right is-pulled-right">{children}</div>
);

export default PullRight;
